import type { IPortalBridge } from './types';

/**
 * @desc Portal bridge exposes selected portal capabilities to external consumers
 * (e.g. Sanity Studio fragments) via `window.bridge`.
 */
export class PortalBridge implements IPortalBridge {
  navigation: IPortalBridge['navigation'];

  constructor(getCurrentRoute: () => string) {
    this.navigation = {
      getCurrentRoute,
    };
  }
}
